module.exports = __webpack_public_path__ + "assets/3c41387aa50fe80dcccc9db7824e9190.jpg";